export default class APIDownloads {

  getHeadersWithContentType(arg0: string | undefined): HeadersInit | undefined {
    throw new Error("Method not implemented.");
  }

  getURLSearchParams(object: any) {
    throw new Error("Method not implemented.");
  }

  async getAssignedURLS(query: any) {

    const params = this.getURLSearchParams(query);
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/buckets/urls/?${params}`, {
      method: 'GET',
      headers: this.getHeadersWithContentType('application/json'),
    });

    if (!response.ok) {
      return false;
    }

    const json = await response.json();
    return json;
  }
}